
import Reports from './Reports.js'
import fbpReports from './fbpReports.js';
export default {
  namespaced: true,
  modules:{
    Reports: Reports,
    fbpReports: fbpReports
  }
};